/**
 * 复制文本（String中加入 /n 可换行）
 * @param {String} text
*/
import { Message } from 'element-ui';

export function copy(text) {
  if (!text) return
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
    Message.success('复制成功')
  } catch (error) {
    Message.error('当前浏览器不支持复制')
  }
}